import { FaAngleDown } from "react-icons/fa";
import { RiLogoutBoxLine } from "react-icons/ri";

interface SucursalColoresProps {
    register: any;
    watch: any;
    compania: any;
    logo_primario_guardado: string;
    logoPrincipalBase64: string | null;
}

export const SucursalColores = ({ register, watch, compania, logo_primario_guardado, logoPrincipalBase64 }: SucursalColoresProps) => {
    return (
        <>
            <h6 className="px-2">Colores del menú</h6>
            <div className="col-12 col-lg-6">
                <div className="row g-3">
                    <div className="col-12 col-lg-12">
                        <div className="d-flex align-items-top">
                            <label className="col-6 col-lg-8 text-start px-2">Fondo</label>
                            <input
                                {...register("color_fondo_menu_primario")}
                                type="color"
                                className="form-control form-control-sm"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <div className="col-12 col-lg-12">
                        <div className="d-flex align-items-top">
                            <label className="col-6 col-lg-8 text-start px-2">Texto de las opciones</label>
                            <input
                                {...register("color_texto_nav_item")}
                                type="color"
                                className="form-control form-control-sm"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <div className="col-12 col-lg-12">
                        <div className="d-flex align-items-top">
                            <label className="col-6 col-lg-8 text-start px-2">Fondo de opciones activo</label>
                            <input
                                {...register("color_fondo_nav_item_activo")}
                                type="color"
                                className="form-control form-control-sm"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <div className="col-12 col-lg-12">
                        <div className="d-flex align-items-top">
                            <label className="col-6 col-lg-8 text-start px-2">Texto de opciones activo</label>
                            <input
                                {...register("color_texto_nav_item_activo")}
                                type="color"
                                className="form-control form-control-sm"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                </div>

            </div>
            <div className="col-12 col-lg-6 d-flex justify-content-center">
                <div className="sidebar" style={{ background: watch("color_fondo_menu_primario") || compania?.estilo?.fondo_menu, width: "10rem", height: "13rem", padding: "10px !important" }}>
                    <div className="top_section justify-content-center" style={{ position: "relative" }}>

                        {/* <h1 className="logo text-center text-white"
                                                style={{ flex: 1, alignSelf: 'end' }}>
                                                LOGO
                                            </h1> */}
                        {
                            (logo_primario_guardado !== "" || logoPrincipalBase64 != null) && (
                                <div className="col-lg-8 mx-auto d-flex justify-content-center align-items-center" style={{ height: "28px", width: "28px" }}>
                                    <img
                                        src={logoPrincipalBase64 || logo_primario_guardado}
                                        alt="Imagen logo 1"
                                        className="img-thumbnail"
                                    />
                                </div>
                            )}
                        {/* <div className="text-center d-flex align-items-end justify-content-center" style={{ position: "absolute", right: "10px" }}>
                                                <FaBars className="color-iconos" style={{ color: watch("color_button_primario"), fontSize: "18px" }} />
                                            </div> */}
                        {
                            (logo_primario_guardado === "" && logoPrincipalBase64 == null) && (
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M4 2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1ZM4 5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM7.5 5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1ZM4.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1Zm3.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1Z">
                                        </path>
                                        <path d="M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V1Zm11 0H3v14h3v-2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V15h3V1Z">
                                        </path>
                                    </svg>
                                </div>
                            )
                        }

<div {...({ class: "bars text-center d-flex align-items-end justify-content-center" } as any)} style={{ position: "absolute", right: "8px", color: watch("color_texto_nav_item") }}><svg stroke="currentColor" fill="currentColor" {...({ "stroke-width": "0" } as any)} viewBox="0 0 448 512" /*  class="color-iconos"  */ height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" style={{ fontSize: "18px" }}><path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path></svg></div>

                    </div>
                    <section className="routes">
                        <div className="usuario text-center p-0 m-0"><span className="ms-1" style={{ fontSize: "0.688rem", color: watch("color_texto_nav_item") }}>User</span></div>
                        {/* preview decorativo del menú (sin navegación real) */}
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a className="none link"
                            style={{ cursor: "pointer", color: watch("color_texto_nav_item") }}
                            onMouseEnter={(e) => {
                                // Cambiar el color de fondo y el color del texto en hover
                                e.currentTarget.style.backgroundColor = watch("color_fondo_nav_item_activo"); // Color de fondo en hover
                                e.currentTarget.style.color = watch("color_texto_nav_item_activo"); // Color de texto en hover
                            }}
                            onMouseLeave={(e) => {
                                // Volver a los estilos predeterminados al dejar de hacer hover
                                e.currentTarget.style.backgroundColor = "transparent"; // Color de fondo predeterminado
                                e.currentTarget.style.color = watch("color_texto_nav_item"); // Color de texto predeterminado
                            }}
                        >
                            <div className="link_text">
                                Opción 1
                            </div>

                        </a>
                        <div className="menu">
                            <div className="menu_item" style={{ cursor: "pointer" }}>
                                <div className="icon"></div>
                                <div className="link_text" style={{ color: watch("color_texto_nav_item") }}>Opción 2</div>
                            </div>
                            <div style={{ transform: "none" }}>
                                <FaAngleDown />
                            </div>
                        </div>
                        {/* preview decorativo del menú (sin navegación real) */}
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a aria-current="page" className="none link"
                            style={{ cursor: "pointer", color: watch("color_texto_nav_item") }}
                            onMouseEnter={(e) => {
                                // Cambiar el color de fondo y el color del texto en hover
                                e.currentTarget.style.backgroundColor = watch("color_fondo_nav_item_activo"); // Color de fondo en hover
                                e.currentTarget.style.color = watch("color_texto_nav_item_activo"); // Color de texto en hover
                            }}
                            onMouseLeave={(e) => {
                                // Volver a los estilos predeterminados al dejar de hacer hover
                                e.currentTarget.style.backgroundColor = "transparent"; // Color de fondo predeterminado
                                e.currentTarget.style.color = watch("color_texto_nav_item"); // Color de texto predeterminado
                            }}
                        >
                            <div>
                                <RiLogoutBoxLine className="color-iconos" style={{ fontSize: "24px", color: watch("color_texto_nav_item") }} />
                            </div>
                            <div className="link_text">salir</div>
                        </a>
                    </section>
                </div>
            </div>

            <h6 className="px-2">Colores de botones</h6>

            <div className="col-12 col-lg-4">
                <div className="row g-3">
                    <div className="col-12 col-lg-12">
                        <div className="d-flex align-items-top">
                            <label className="col-6 col-lg-8 text-start px-2">Botón primario</label>
                            <input
                                {...register("color_button_primario")}
                                type="color"
                                className="form-control form-control-sm"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <div className="col-12 col-lg-12">
                        <div className="d-flex align-items-top">
                            <label className="col-6 col-lg-8 text-start px-2">Botón primario activo</label>
                            <input
                                {...register("color_button_primario_hover")}
                                type="color"
                                className="form-control form-control-sm"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <div className="col-12 col-lg-12">
                        <div className="d-flex align-items-top">
                            <label className="col-6 col-lg-8 text-start px-2">Texto del botón primario</label>
                            <input
                                {...register("color_button_primario_texto")}
                                type="color"
                                className="form-control form-control-sm"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12 col-lg-2 d-flex justify-content-center align-items-center">
                <div className="p-3 border">
                    <button
                        className="btn btn-sm btn-primario"
                        type="button"
                        style={{ background: watch("color_button_primario"), color: watch("color_button_primario_texto") }}
                        onMouseEnter={(e) => {
                            // Cambiar el color de fondo y el color del texto en hover
                            e.currentTarget.style.backgroundColor = watch("color_button_primario_hover"); // Color de fondo en hover
                            e.currentTarget.style.color = watch("color_button_primario_texto"); // Color de texto en hover
                        }}
                        onMouseLeave={(e) => {
                            // Volver a los estilos predeterminados al dejar de hacer hover
                            e.currentTarget.style.backgroundColor = watch("color_button_primario"); // Color de fondo predeterminado
                            e.currentTarget.style.color = watch("color_button_primario_texto"); // Color de texto predeterminado
                        }}

                    >Guardar</button>
                </div>

            </div>

            <div className="col-12 col-lg-4">
                <div className="row g-3">
                    <div className="col-12 col-lg-12">
                        <div className="d-flex align-items-top">
                            <label className="col-6 col-lg-8 text-start px-2">Botón secundario</label>
                            <input
                                {...register("color_button_secundario")}
                                type="color"
                                className="form-control form-control-sm"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <div className="col-12 col-lg-12">
                        <div className="d-flex align-items-top">
                            <label className="col-6 col-lg-8 text-start px-2">Botón secundario activo</label>
                            <input
                                {...register("color_button_secundario_hover")}
                                type="color"
                                className="form-control form-control-sm"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                    <div className="col-12 col-lg-12">
                        <div className="d-flex align-items-top">
                            <label className="col-6 col-lg-8 text-start px-2">Texto del botón secundario</label>
                            <input
                                {...register("color_button_secundario_texto")}
                                type="color"
                                className="form-control form-control-sm"
                                autoComplete="off"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12 col-lg-2 d-flex justify-content-center align-items-center">
                <div className="p-3 border">
                    <button
                        className="btn btn-sm btn-secundario"
                        type="button"
                        style={{ background: watch("color_button_secundario"), color: watch("color_button_secundario_texto") }}
                        onMouseEnter={(e) => {
                            // Cambiar el color de fondo y el color del texto en hover
                            e.currentTarget.style.backgroundColor = watch("color_button_secundario_hover"); // Color de fondo en hover
                            e.currentTarget.style.color = watch("color_button_secundario_texto"); // Color de texto en hover
                        }}
                        onMouseLeave={(e) => {
                            // Volver a los estilos predeterminados al dejar de hacer hover
                            e.currentTarget.style.backgroundColor = watch("color_button_secundario"); // Color de fondo predeterminado
                            e.currentTarget.style.color = watch("color_button_secundario_texto"); // Color de texto predeterminado
                        }}
                    >
                        Cancelar
                    </button>
                </div>

            </div>
        </>
    )
}
